import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {I18n} from '@aws-amplify/core';
import {deleteRecord} from "../services/BillingProvidersService.ts";
import {useBillingProvidersSelection} from "../hooks/useBillingProvidersSelection.ts";
import {billingProvidersQueryKeys} from "../hooks/billingProvidersQueryKeys.ts";
import {notifyError, notifySuccess} from '../../../components/ServiceNotifications.tsx';

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useBillingProvidersSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: () => Promise.all(selectedRecords.map(record => deleteRecord(record.id))),
        onSuccess: (deleted) => {
            clearSelection();
            notifySuccess(deleted.length === 1
                              ? I18n.get('Billing Provider deleted')
                              : `${deleted.length} ${I18n.get('billing providers deleted')}`);
        },
        // A failure must be seen (§8). Selection is kept so the operator can retry.
        onError: (error) => notifyError(error),
        // Settled, not success: when one of several deletes fails, the ones that landed
        // must still leave the list.
        onSettled: () => queryClient.invalidateQueries({queryKey: billingProvidersQueryKeys.all}),
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
